import { Store } from '../../types'

export const liabilityMappingSelector = (store: Store) => store.config.liabilityMapping
